import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkPortal, PortalModule } from '@angular/cdk/portal';
import { PortalBridgeService } from '../portal-bridge.service';

@Component({
  selector: 'markant-platform-modal-bridge',
  standalone: true,
  imports: [CommonModule, PortalModule],
  templateUrl: './modal-bridge.component.html',
  styleUrls: ['./modal-bridge.component.scss'],
})
export class ModalBridgeComponent implements OnInit, OnDestroy {
  @ViewChild(CdkPortal, { static: true }) portalContent!: CdkPortal;
  constructor(private readonly portalBridge: PortalBridgeService) {}

  ngOnInit(): void {
    this.portalBridge.setPortal(this.portalContent);
  }

  ngOnDestroy(): void {
    this.portalBridge.removePortal(this.portalContent);
    if (this.portalContent.isAttached) {
      this.portalContent.detach();
    }
  }
}
